import { ChangeDetectionStrategy, Component, DestroyRef, Signal, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TRANSLOCO_SCOPE, Translation, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { ButtonType } from 'app/core/dialogBuilder/dialog-builder.models';
import { DialogBuilderService } from 'app/core/dialogBuilder/dialog-builder.service';
import { ProcessFilterService } from './process-filter.service';
import { ProcessesFilterDialogComponent } from './processes-filter-dialog/processes-filter-dialog.component';

@Component({
    selector: 'processes-filter',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslocoModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
    ],
    templateUrl: './processes-filter.component.html',
    styleUrl: './processes-filter.component.scss',
    providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'bp' }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessesFilterComponent {
    private _translocoContent: Signal<Translation> = toSignal(
        this._translocoService.selectTranslation('bp')
    );

    filterValuesForm: FormGroup;

    executeActionSignal = signal<string>(null);

    constructor(
        private _translocoService: TranslocoService,
        private _dialogService: DialogBuilderService,
        private _processFilterService: ProcessFilterService,
        private _formBuilder: FormBuilder,
        private _destroyRef: DestroyRef
    ) {
        this.filterValuesForm = this._formBuilder.group({
            searchString: this._processFilterService.filterValues().searchString,
        });

        this.filterValuesForm.valueChanges
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(values => {
                this._processFilterService.updateFilterValues(values);
            });
    }

    clearSearchString() {
        this.filterValuesForm.get('searchString').setValue('');
    }

    openFilterDialog() {
        let dialogRef = this._dialogService.openDialog({
            descriptor: {
                header: {
                    title: this._translocoContent()['filterOptions'],
                    showCloseButton: true,
                },
                content: {
                    componentConfig: {
                        component: ProcessesFilterDialogComponent,
                        componentData: {
                            model: this._processFilterService.filterValues(),
                        },
                    },
                },
                actions: {
                    dialogActions: [
                        {
                            code: 'cancel',
                            style: ButtonType.simple,
                            title: this._translocoContent()['cancel'],
                            dismiss: true,
                        },
                        {
                            code: 'reset',
                            style: ButtonType.raised,
                            color: 'warn',
                            title: this._translocoContent()['reset'],
                            manualClose: true,
                            // hide: !hasFilters,
                        },
                        {
                            code: 'filter',
                            style: ButtonType.raised,
                            color: 'primary',
                            title: this._translocoContent()['filter'],
                            manualClose: true,
                        },
                    ],
                },
                executeActionSignal: this.executeActionSignal,
                dialogSize: 'm',
            },
        });
    }
}
